import client from '../client'

export const getTargetedOffersCount = async (token: string): Promise<number> => {
    return client.request<{ items: Array<unknown> }>({
        url: '/user/offers/targeted',
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
        method: 'get',
    }).then((response) => {
        return response?.data?.items?.length || 0
    }).catch((err) => {
        console.error(err)
        return 0
    })
}